import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Sidebar from "./AdminSidebar";
import Navbar from "./AdminNavbar";
import { useState } from "react";

const drawerWidth = 240;
const collapsedWidth = 64;
const anchor = "right"; // Sidebar on the right

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const sidebarWidth = sidebarOpen ? drawerWidth : collapsedWidth;

  return (
    <Box sx={{ display: "flex" }}>
      <Sidebar
        drawerWidth={drawerWidth}
        collapsedWidth={collapsedWidth}
        open={sidebarOpen}
        onToggle={() => setSidebarOpen((prev) => !prev)}
        anchor={anchor}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "background.default",
          minHeight: "100vh",
          ...(anchor === "left" ? { ml: `${sidebarWidth}px` } : { mr: `${sidebarWidth}px` }),
        }}
      >
        <Navbar sidebarWidth={sidebarWidth} anchor={anchor} />

        <Box sx={{ p: 3, mt: 8 }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
